import React from 'react';
import { useParams } from 'react-router-dom';
import { StyleSheet, Text, View } from './components/base_components';

import Breadcrumb from './components/breadcrumb';
import BreadcrumbPath from './components/breadcrumb_path';
import ProgressSpinner from './components/progress_spinner';
import MediaDirList from './components/media_dir_list';
import MediaFile from './components/media_file';
import TitleActionLine from './components/title_action_line';

import DirStore from './stores/dir_store';
import MediaGrantStore from './stores/media_grant_store';
import UserStore from './stores/user_store';

const styles = StyleSheet.create({
  mediaGrantScreen: {
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
  },
  spinner: { margin: '3rem', alignSelf: 'center' },
  dialog: { marginLeft: '3rem', flexDirection: 'column' },
  text: { marginTop: '1em', fontSize: '1.5em' },
});

export default function MediaGrantScreen(props) {
  const params = useParams();
  const org = UserStore.useOrg();
  const grant_name = params.grant_name ?? '';
  const path = '/' + decodeURIComponent(params['*'] ?? '');
  const grant = MediaGrantStore.useMediaGrant(org?.org_id, grant_name);
  const media_grant_id = grant?.media_grant_id;
  const source_dir = DirStore.useList(media_grant_id, path);
  const is_folder = path.endsWith('/');

  React.useEffect(() => {
    MediaGrantStore.fetch(org?.org_id);
  }, [org?.org_id]);
  React.useEffect(() => {
    if (media_grant_id) {
      DirStore.fetch({ org_id: org?.org_id, media_grant_id, path });
    }
  }, [org?.org_id, media_grant_id, path]);

  let content: any = null;
  if (grant === null) {
    let inner: any;
    if (org?.is_admin) {
      inner = (
        <View style={styles.dialog}>
          <Text style={styles.text}>
            Looks like you don't have access to this container.
          </Text>
          <Text style={styles.text}>
            Modify the volume to add yourself to this container.
          </Text>
        </View>
      );
    } else {
      inner = (
        <View style={styles.dialog}>
          <Text style={styles.text}>
            Looks like you don't have access to this container.
          </Text>
          <Text style={styles.text}>
            Contract your organization's administrator to get access.
          </Text>
        </View>
      );
    }
    content = (
      <>
        <Breadcrumb list={[{ text: 'Home', url: `/` }, grant_name]} />
        <TitleActionLine title={grant_name} />
        {inner}
      </>
    );
  } else if (!source_dir) {
    content = <ProgressSpinner style={styles.spinner} color='#555' />;
  } else if (is_folder) {
    content = (
      <MediaDirList
        org={org}
        mediaGrant={grant}
        path={path}
        sourceDir={source_dir}
      />
    );
  } else {
    const media =
      path.toLowerCase() ===
      source_dir.media_list?.[0]?.media_path?.toLowerCase?.()
        ? source_dir.media_list[0]
        : null;
    content = (
      <MediaFile org={org} mediaGrant={grant} path={path} media={media} />
    );
  }

  return (
    <View style={styles.mediaGrantScreen}>
      {grant ? (
        <BreadcrumbPath
          volumeName={grant.grant_name}
          prefix={`/home/${grant.grant_name}/`}
          path={path}
        />
      ) : null}
      {content}
    </View>
  );
}
